module.exports = __webpack_public_path__ + "static/media/goodmorning-america.47e1d20b.gif";